import {Pipe, PipeTransform} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl} from '@angular/platform-browser';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Pipe({
  name: 'secure'
})
export class SecureURL implements PipeTransform {

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  transform(url): Observable<SafeUrl> {

    return this.http
      .get(url, { responseType: 'blob' })
      .pipe(map(val => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val))));

  }

  /*transform(url, type: string):Observable<SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl> {
    switch (type) {
      case 'html':
        return this.http.get(url,{responseType:'text'}).pipe(map(val=>this.sanitizer.bypassSecurityTrustHtml(val)));
      case 'image':
        return this.http.get(url,{responseType:'blob'}).pipe(map(val=>this.sanitizer.bypassSecurityTrustUrl((URL.createObjectURL(val)))));
      case 'resourceUrl':
        return this.http.get(url,{responseType:'text'}).pipe(map(val=>this.sanitizer.bypassSecurityTrustResourceUrl(val)));
      default:
        return this.http.get(url,{responseType:'text'}).pipe(map(val=>this.sanitizer.bypassSecurityTrustHtml(val)));
    }
  }*/
}
